import Default from "./BorderedListItem";
export * from "./BorderedListItem";

export default Default;
